import { Button } from '@mui/material'
import { FileText } from 'lucide-react'

import { AttachmentsVariantProps } from '#/components/FormatCell/Types/attachments/types'

export function AttachmentsIconText({ filename, onClick }: AttachmentsVariantProps) {
  return (
    <Button startIcon={<FileText size={16} />} onClick={onClick} color="secondary" sx={{ px: 2 }}>
      {filename}
    </Button>
  )
}
